import api from 'src/services/api';
import * as utils from './apiUtils';
import {
  type AdminGroup3IndexResponse,
  type AdminGroup3Response,
  toAdminGroup3,
} from 'src/models/apis/group3/adminGroup3Response';
import type { AdminGroup3 } from 'src/models/group3';
import type { AdminGroup3Params } from 'src/models/apis/group3/adminGroup3Request';

export default {
  async adminIndex(): Promise<AdminGroup3[]> {
    const response = await api.get<AdminGroup3IndexResponse>(utils.getApiUrl('/admin/groups3'));
    return response.data.map(toAdminGroup3);
  },
  async adminCreate(params: AdminGroup3Params): Promise<AdminGroup3> {
    const response = await api.post<AdminGroup3Response>(utils.getApiUrl('/admin/groups3'), params);
    return toAdminGroup3(response.data);
  },
  async adminUpdate(id: number, params: AdminGroup3Params): Promise<AdminGroup3> {
    const response = await api.put<AdminGroup3Response>(utils.getApiUrl(`/admin/groups3/${id}`), params);
    return toAdminGroup3(response.data);
  },
  async adminDestroy(id: number): Promise<AdminGroup3> {
    const response = await api.delete<AdminGroup3Response>(utils.getApiUrl(`/admin/groups3/${id}`));
    return toAdminGroup3(response.data);
  },
};
